<template>
    <tr>
        <td>{{ bid.user.name }}</td>
        <td>{{ bid.bid }}</td>
        <td>{{ bid.model_type }}</td>
        <td>{{ bid.grade_en }}</td>
        <td>{{ bid.mileage_num }}</td>
        <td>{{ bid.model_year }}</td>
        <td>{{ bid.color }}</td>
        <td>{{ bid.displacement_num }}</td>
        <td>{{ bid.scores }}</td>
        <td>{{ bid.amount }}</td>
        <!--<td>-->
            <!--<span :class="statusLabels[bid.status].tagClass">{{ statusLabels[bid.status].label }}</span>-->
        <!--</td>-->
        <td>{{ bid.end_price_en }}</td>
    </tr>
</template>

<script>
    export default {
        props: ['bid'],
        data() {
            return {
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other client'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Under negotiations'
                    },
                ],
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/History/HistoryTableRow.vue